import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { SimpleProduct } from '../../../inputs';
import { SubmitResponse } from '../../../models';
import { HttpService } from '../http.service';


@Injectable({
  providedIn: 'root'
})
export class AddProductService extends HttpService<SimpleProduct, SubmitResponse> {
  constructor(
    httpClient: HttpClient,
    @Inject('API_URL') apiUrl: string,
    @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'product');
  }

  createProduct(product: SimpleProduct ): Observable<SubmitResponse> {
    return this.create(product, '');
  }

  updateProduct(product: SimpleProduct): Observable<SubmitResponse> {
    return this.patchWithID(product,'smart-update');
  }

}
